<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    ref="frame"
    class="popup-wrapper">
    <div class="flex flex-col popup-background" tabindex="1">
      <div class="send-reminder-cont">
        <p>Yeni <strong>Bölge</strong> eklemek için formu doldurum ve Onayla tuşuna basın. </p>
      </div>
      <div class="flex flex-col">
        <div class="regular-input-field">
          <input class="w-full regular-input"
                 type="text"
                 v-model="name"
                 placeholder="Bölge Adi"
                 data-vv-name="Bolge Adi"
                 v-validate="'required'">

          <span class="text-danger text-sm" v-show="errors.has('Bolge Adi')">{{ errors.first('Bolge Adi') }}</span>
        </div>
        <div class="regular-input-field">
          <textarea class="w-full regular-textarea"  name="Description" v-model="description" placeholder="Açıklayıcı kısa metin..."
                    data-vv-name="Bolge Aciklama"
                    v-validate="'required'"></textarea>

          <span class="text-danger text-sm" v-show="errors.has('Bolge Aciklama')">{{ errors.first('Bolge Aciklama') }}</span>
        </div>
      </div>
      <div class="w-full mt-4">
        <div class="popup-button blue-button" @click="confirm">Onayla</div>
        <div class="popup-button black-button" @click="cancel">Vazgeç</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    updated: {
      type: Function
    },
    cancelled: {
      type: Function
    },
    code: {
      type: String
    },
    bolge: {
      type: Object
    }
  },
  name: 'BolgePopup',
  mounted () {
    if (this.bolge) {
      this.loadData(this.bolge)
    }
  },
  data () {
    return {
      name: '',
      description: ''
    }
  },
  computed: {
  },
  methods: {
    handleFocus () {
      // do something here
      console.log('in')
      this.cancel()
    },
    handleFocusOut () {
      // do something here
      console.log('out')
    },
    loadData (data) {
      const { name, description } = JSON.parse(JSON.stringify(data))
      this.name = name
      this.description = description
    },
    resetData () {
      this.name = ''
      this.description = ''
    },
    addBolge (payload) {
      console.log('addBolge payload', payload)
      this.$store.dispatch('addBolge', payload)
        .then((response) => {
          console.log('bolge', response)
          this.$vs.loading.close()
          this.updated(response)
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },
    editBolge (payload) {
      console.log('editBolge payload', payload)
      this.$store.dispatch('editBolge', payload)
        .then((response) => {
          console.log('bolge', response)
          this.$vs.loading.close()
          this.updated(response)
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },
    confirm () {
      //this.updated(this.code)
      return new Promise(() => {
        this.$validator.validateAll().then(result => {
          if (result) {
            const payload = {
              name: this.name,
              description: this.description
            }
            console.log('bolge payload', payload)
            if (this.bolge) {
              payload.id = this.bolge.id
              this.editBolge(payload)
            } else {
              this.addBolge(payload)
            }
          } else {
            this.$vs.notify({
              title: 'Hata',
              text: 'Lütfen gerekli alanları doldurun',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          }
        })
      })
    },
    cancel () {
      this.resetData()
      this.cancelled()
    }
  }
}
</script>

<style lang="scss">

</style>
